import { msg, optionalEmailSchema } from '~/utils/validation';
import { z } from 'zod';

export const baseSchema = z.object({
  email: optionalEmailSchema,
  website: z
    .string()
    .refine(val => val === '' || /^https?:\/\/.+/.test(val), {
      message: msg.website,
    })
    .nullish(),
});

export const schema = z
  .object({
    name: z.string().min(1, { message: msg.required }),
    district: z.coerce
      .string()
      .min(1, { message: msg.required })
      .transform(v => (v ? Number(v) : undefined)),
    is_active: z.boolean().optional(),
  })
  .merge(baseSchema);

export type Schema = z.infer<typeof schema>;
